import Loader from "react-loader-spinner";
import { faCalculator } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Button, Card, Col, Form, Row } from "react-bootstrap";
import { getServiceAccountingList, getStaffPerformance_ServiceCostList, getStaffPerformance_ServiceTotalCost } from "../store/api/Services";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { exportToExcel, isWebApp, keyIsLetterOrNumber, setErrorDialog, useIsMobileApp } from "../../store/api/CommonFunctions";
import DatePicker from "react-datepicker2";
import BihamtaTable from "../../Components/BihamtaTable";
import { ClipboardData, FileEarmarkExcelFill, List, PrinterFill, Search } from "react-bootstrap-icons";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import ModalSelectStaff from "../../Components/Modals/ModalSelectStaff";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const StaffPerformanceServiceCostList = () => {

    const history = useHistory();
    const { staffID } = useParams();
    const isMobile = useIsMobileApp();
    const [selectedStaff, setSelecedStaff] = useState(null);
    const dispatch = useDispatch();
    const { filterData, parentFilterData, dataList } =
        useSelector(state => {
            return {
                parentFilterData: state.service.srvTotalCostFilters,
                filterData: state.service.staffSRVCostListFilters,
                dataList: state.service.staffSRVCostList
            }
        });
    let staffName = "";
    if (Number(staffID) > 0) {
        if (Array.isArray(dataList?.Data) && dataList.Data.length > 0)
            staffName = dataList.Data[0].StaffName;
    }
    else {
        staffName = selectedStaff?.LastName;
    }
    if (staffName?.length > 0) {
        staffName = " - " + staffName;
    }
    const [pending, setPending] = useState(false);
    const [popStaff, setPopStaff] = useState({ show: false });
    const settingNames = ['ProductGrouppingType'];
    const tableCols = [
        { colName: "RowNumber", colTitle: "ردیف", showInMobile: true },
        { colName: "PServiceType", colTitle: "نوع سرویس", showInMobile: true },
        { colName: "PFirstContactDate", colTitle: "تاریخ پذیرش", showInMobile: true },
        { colName: "InvoiceNumber", colTitle: "شماره سرویس" },
        { colName: "PRowType", colTitle: "نوع خدمت", showInMobile: true },
        { colName: "CostDesc", colTitle: "شرح خدمت" },
        { colName: "Status", colTitle: "وضعیت" },
        { colName: "ServiceCount", colTitle: "تعداد", colType: "currency" },
        { colName: "ServiceCost", colTitle: "مبلغ واحد", colType: "currency" },
        { colName: "RowDiscount", colTitle: "تخفیف", colType: "currency" },
        { colName: "TaxAmount", colTitle: "مالیات", colType: "currency" },
        { colName: "StaffShare", colTitle: "سهم تکنسین", colType: "currency" }
    ]
    function search() {
        const data = { ...parentFilterData };
        data.StaffID = Number(staffID) > 0 ? staffID : selectedStaff?.ID;
        if (!(data.StaffID > 0)) {
            setErrorDialog(dispatch, "تکنسینی انتخاب نشده است", "گزارش ماهانه عملکرد تکنسین");
            return;

        }
        //data.StaffHardCode = staffHardCode;
        data.Skip = 0;
        data.Take = 10;
        dispatch(getStaffPerformance_ServiceCostList(data));

    }
    function onFilterChanged(value, name) {
        const data = { ...filterData, Skip: 0 };
        data[name] = value;
        if (isNaN(data.Take)) {
            data.Take = 10;
        }
        dispatch(getStaffPerformance_ServiceCostList(data));
    }
    function toExcel() {
        const url = `api/ServiceReportsAPI/getStaffPerformance_ServiceCostList`;
        const searchArgs = { ...filterData };
        searchArgs.Take = 0;
        searchArgs.Skip = 0;
        setPending(true);
        exportToExcel("StaffPerformanceServiceCostList", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    function printReport(e) {
        const searchArgs = { ...filterData };
        searchArgs.Take = 0;
        searchArgs.Skip = 0;
        history.push({
            pathname: `/PrintViewer/StaffPerformanceServiceCostList/${e.ctrlKey}`,
            state: {
                dataUrl: `api/ServiceReportsAPI/getStaffPerformance_ServiceCostList`,
                method: "post",
                fetchBody: JSON.stringify(searchArgs)
            }
        });
    }
    function gotoService(row) {
        history.push(`/Services/Service/${row.ServiceID}/${row.ServiceType}`);
    }
    function showModalStaff(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelect = (data) => {
            setSelecedStaff(data);
            onFilterChanged(data.ID, "StaffID");
        }
        setPopStaff({ show: true, onSelect: onSelect });
    }
    useEffect(() => {
        dispatch(getSystemSettings(settingNames));
        document.body.classList = "notMain";
        document.title = "بی همتا-خدمات";
    }, [])
    useEffect(() => {
        if (staffID > 0)
            search();
    }, [staffID])
    return (
        <div className="container-fluid mt-1">
            <br />
            <Card>
                <ModalSelectStaff popData={popStaff} setPopSelectStaff={setPopStaff} />
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faCalculator} size="lg" />&nbsp;
                    گزارش عملکرد تکنسین(لیستی){staffName}
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <Row className="text-end">
                        {!(staffID > 0) &&
                            <Col md={2} className="form-group">
                                <label>مشخصات تکنسین: </label>
                                <div>
                                    <input className="search-input" readOnly value={selectedStaff?.LastName ?? ""} onKeyDown={showModalStaff} />
                                    <Button className="btn-input-tiny" onClick={showModalStaff} style={{ top: "50%", transform: "translateY(-50%)", left: 2 }}><List size={18} /></Button>
                                </div>
                            </Col>}
                        {/* <Col md={2} className="form-group" >
                            <label>تعداد در صفحه: </label>
                            <select className="search-input" onChange={e => onFilterChanged(e.target.value, "Take")} defaultValue={!(Number(staffID) > 0) && 10}>
                                <option value={0}>انتخاب کنید</option>
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                        </Col> */}
                    </Row>
                    {!pending &&
                        <div style={{ padding: 1, width: "100%", textAlign: "left", marginTop: "5px" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                            <PrinterFill color="blue" size={25} style={{ cursor: "pointer" }} className="hoverIcon" onClick={printReport} />
                        </div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable columns={tableCols} reducerName="service" searchMethod={(data) => dispatch(getStaffPerformance_ServiceCostList(data))}
                        objectName="staffSRVCostList" filterData={filterData} hasPaging className="mt-0" rowClick={gotoService} style={{ whiteSpace: "nowrap" }} maxHeight={350} pageSizeList={[0, 10, 20, 50, 100]} />
                    {!isMobile &&
                        <div className="mt-1" style={{ color: "blue", textAlign: "left" }}>
                            برای نمایش سرویس روی ردیف مورد نظر کلیک کنید
                        </div>
                    }
                </Card.Body>
            </Card>
        </div>)
}
export default StaffPerformanceServiceCostList;